import { Component, Input } from '@angular/core';
import { Projects, Logs, Activities, Updates } from 'api/collections';
import { Project, Log, LogType, LogCategories, Update, Activity} from 'api/models';
import * as moment from 'moment';
import { MeteorObservable } from 'meteor-rxjs';
import { LogView } from '../../pages/log-view/log-view';
import { AugmentedActivity } from '../../services/activityData';
import { NewLogComponent } from '../../pages/new-log/new-log';
import { ActivityDetailsPage } from '../activity-details/activity-details';
import * as permissions from '../../services/permissions';
import { ISDEV, APP_TITLE } from '../../services/config';

export type SortOptions = Array<{
  label: string,
  value: string,
}>;

@Component({
  selector: 'activity-overview',
  templateUrl: 'activity_overview.html',
  styleUrls: ['/directives/activity_overview/activity_overview.scss']
})
export class ActivityOverview {
  @Input() activity: AugmentedActivity;
  @Input() update: Update;

   public isDev = ISDEV;


  constructor() {

  }



  getMilestoneActivityIconName(activity) {
    if (activity.activityStatus == 'TK_NotStart') {
      return 'close-circle';
    } else if (activity.activityStatus == 'TK_Complete'){
      return 'checkmark-circle';
    }
  }

}



// WEBPACK FOOTER //
// ./src/directives/activity_overview/activity_overview.component.ts